import React, { useMemo } from 'react'
import { getElementId, useWebformElement } from '../utils';

import WebformElementWrapper from './webformElementWrapper';
import Select from 'react-select'
import { useColorMode } from 'theme-ui';
import { transparentize, lighten, darken } from "polished";
import { getThemeColor } from "../../../utils";

export const DEFAULT_SELECT_LABEL = '-- Select --';

export const WebformSelect = ({ element, error, onChange = () => null, color, columns }) => {
	const id = getElementId(element.name);
	const [inputProps, settings] = useWebformElement(element, {
		className: 'form-control',
		name: element.name,
		id
	});

	const [colorMode] = useColorMode();

	const customStyles = useMemo(() => ({
		control: (provided) => ({
			...provided,
			backgroundColor: getThemeColor('background', colorMode),
			borderColor: transparentize(0.8, getThemeColor('text', colorMode)),
			minHeight: 33,
			color: getThemeColor('text', colorMode),
			cursor: 'none !important',
		}),
		option: (provided) => ({
			...provided,
			backgroundColor: getThemeColor('background', colorMode),
			borderColor: transparentize(0.8, getThemeColor('text', colorMode)),
			color: getThemeColor('text', colorMode),
			cursor: 'none !important',
			'&:hover': {
				backgroundColor: (colorMode === 'default' ? darken : lighten)(0.1, getThemeColor('background', colorMode)),
				zIndex: 5,
			},
			'&:not(:last-of-type)': {
				borderBottom: '1px solid',
				borderColor: transparentize(0.8, getThemeColor('text', colorMode)),
			}
		}),
		singleValue: (provided) => ({
			...provided,
			color: getThemeColor('text', colorMode),
		}),
		menu: (provided) => ({
			...provided,
			backgroundColor: getThemeColor('background', colorMode),
			border: '1px solid',
			borderRadius: '4px',
			borderColor: transparentize(0.8, getThemeColor('text', colorMode)),
			color: getThemeColor('text', colorMode),
			boxShadow: 'none',
			cursor: 'none !important',
		}),
		indicatorsContainer: (provided) => ({
			...provided,
			div: {
				padding: 5,
				svg: {
					path: {
						fill: getThemeColor('text', colorMode),
					}
				}
			}
		}),
		indicatorSeparator: () => ({
			display: 'none',
		})
	}), [colorMode]);

	return (
		<WebformElementWrapper settings={settings} error={error} labelFor={id} color={color} columns={columns}>
			<Select
				{...inputProps}
				onChange={onChange}
				styles={customStyles}
				placeholder={inputProps.placeholder || DEFAULT_SELECT_LABEL}
				options={element.options}
				defaultValue={inputProps.defaultValue || ''}
			/>
		</WebformElementWrapper>
	)
};

export default WebformSelect;
